import { render, staticRenderFns } from "./MyOrdersFilter.vue?vue&type=template&id=63628f3b"
import script from "./MyOrdersFilter.vue?vue&type=script&lang=js"
export * from "./MyOrdersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports